module.exports = __webpack_public_path__ + "img/lines-single-end.06a4d704.png";